import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import UserWelcome from '../app/admins/UserWelcome';
import Admins from '../app/admins';
import Dashboard from '../app/dashboard';
import WorkersList from '../app/workersList';
import ProspectsList from '../app/prospectsList';
import WorkerDetails from '../app/workerDetails';
import CreateWorker from '../app/createWorker';
import References from '../app/workerDetails/References';
import Checkr from '../app/workerDetails/Checkr';
import EmployersList from '../app/employersList';
import EmployerDetails from '../app/employerDetails';
import ConversationsListContainer from '../app/messages/ConversationsListContainer';
import JobsList from '../app/jobsList';
import CreateJobContainer from '../app/createJob/CreateJobContainer';
import JobDetails from '../app/jobDetails';
import EventView from '../app/eventView';
import CompaniesList from '../app/companiesList';
import CompanyDetails from '../app/companyDetails';
import InterviewsList from '../app/interviewsList';
import Schedule from '../app/Schedule';
import Payroll from '../app/payroll';
import Applicants from '../app/applicants';
import Profile from '../app/profile';
import Orientations from '../app/orientations';
import OrientationDetails from '../app/orientationDetails';
import Assessments from '../app/assessments';
import Authorization from './AuthorizationHOC';
import UsersService from '../../services/UsersService';
import ContentWrapper from '../common/ContentWrapper';

const adminAppRole = [UsersService.getRoles().admin];
const employerAppRole = [UsersService.getRoles().employer];
const adminAndEmployerAppRoles = [UsersService.getRoles().admin, UsersService.getRoles().employer];

export const onlyForAdmin = component => Authorization(adminAppRole)(component);
export const onlyForEmployer = component => Authorization(employerAppRole)(component);
const forAdminAndEmployer = component => Authorization(adminAndEmployerAppRoles)(component);

class AdminRouts extends Component {
  shouldComponentUpdate (nextProps) {
    const { location: { pathname }, user: { name } } = this.props;

    return pathname !== nextProps.location.pathname ||
      name !== nextProps.user.name;
  }

  render () {
    const { match } = this.props;
    return (
      <ContentWrapper>
        <Route exact path={`${match.url}`} component={forAdminAndEmployer(UserWelcome)} />
        <Route exact path={`${match.url}/dashboard`} component={onlyForAdmin(Dashboard)} />
        <Route exact path={`${match.url}/admins`} component={onlyForAdmin(Admins)} />
        <Route exact path={`${match.url}/employers`} component={onlyForAdmin(EmployersList)} />
        <Route exact path={`${match.url}/employers/:id`} component={onlyForAdmin(EmployerDetails)} />
        <Route exact path={`${match.url}/prospects`} component={onlyForAdmin(ProspectsList)} />
        <Route exact path={`${match.url}/workers`} component={onlyForAdmin(WorkersList)} />
        <Route exact path={`${match.url}/workers/:id`} component={onlyForAdmin(WorkerDetails)} />
        <Route exact path={`${match.url}/newworker`} component={onlyForAdmin(CreateWorker)} />
        <Route exact path={`${match.url}/messages`} component={forAdminAndEmployer(ConversationsListContainer)} />
        <Route path={`${match.url}/workers/:id/references`} component={onlyForAdmin(References)} />
        <Route path={`${match.url}/workers/:id/checkr`} component={onlyForAdmin(Checkr)} />
        <Route exact path={`${match.url}/companies`} component={onlyForAdmin(CompaniesList)} />
        <Route exact path={`${match.url}/companies/:id`} component={onlyForAdmin(CompanyDetails)} />
        <Route exact path={`${match.url}/jobs`} component={forAdminAndEmployer(JobsList)} />
        <Route exact path={`${match.url}/jobs/:id`} component={forAdminAndEmployer(JobDetails)} />
        <Route exact path={`${match.url}/newjob`} component={forAdminAndEmployer(CreateJobContainer)} />
        <Route exact path={`${match.url}/events/:id`} component={forAdminAndEmployer(EventView)} />
        <Route path={`${match.url}/interviews`} component={onlyForAdmin(InterviewsList)} />
        <Route path={`${match.url}/schedule`} component={onlyForAdmin(Schedule)} />
        <Route path={`${match.url}/payroll`} component={onlyForAdmin(Payroll)} />
        <Route path={`${match.url}/profile`} component={onlyForEmployer(Profile)} />
        <Route exact path={`${match.url}/applicants`} component={onlyForAdmin(Applicants)} />
        <Route exact path={`${match.url}/orientations`} component={onlyForAdmin(Orientations)} />
        <Route exact path={`${match.url}/orientations/:id`} component={onlyForAdmin(OrientationDetails)} />
        <Route exact path={`${match.url}/assessments`} component={onlyForAdmin(Assessments)} />
      </ContentWrapper>
    );
  }
}

export default AdminRouts;



// WEBPACK FOOTER //
// ./src/components/router/AppRouts.js